module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-loading"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("Loading展示")]), _vm._v(" "), _c('div', {
    staticClass: "page-loading__example1"
  }, [_c('zan-loading', {
    staticClass: "some-customized-class",
    staticStyle: {
      "padding-top": "50px",
      "text-align": "center"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62c76611!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/loading.vue
// module id = 293
// module chunks = 0